import styled from 'styled-components';
import { IonCard } from '@ionic/react';

export const IonCardWrapper = styled(IonCard)`
  .tracking-card {
    background-color: var(--ion-color-primary);
  }
  
  .location-display {
    background-color: var(--ion-color-primary);
    color: var(--ion-color-primary-contrast);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: stretch;
    align-items: center;
  
    .address-container {
      flex: 1 1 auto;
  
      .route {
        font-size: 30px;
        margin: 0;
      }
  
      .locality {
        font-size: 15px;
        margin: 0;
      }
  
      .street {
        margin: 0;
      }
    }
  
    .distance-container {
      flex: 0 1 auto;
      display: flex;
      align-items: center;
      justify-content: right;
  
      .distance {
        font-size: 30px;
        border: 2px solid var(--ion-color-primary-shade);
        padding: 10px;
        border-radius: 5px;
        white-space: nowrap;
  
        &.dark {
          border: 2px solid var(--ion-color-primary-tint);
        }
  
        .unit {
          font-size: 15px;
          display: inline-block;
        }
      }
    }
  }
  
  .warning-chip-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1 auto;
  
    .warning-chip {
      overflow: visible;
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
  
  .unavailable-display {
    background-color: #1e1e1e94;
    justify-content: center;

    .spinner {
      position: absolute;
      background-color: #ffffffba;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  .disabled-mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #acacaceb;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    &.dark {
      background-color: #1e1e1eeb;
    }
  }

  &.simple {
    border: none;
  }
`;
